import React from 'react';
import { Star, ExternalLink } from 'lucide-react';

const reviews = [
  {
    name: 'The Freckled Photographer',
    rating: 5,
    date: '3 months ago',
    text: 'Romano Heating and Cooling absolutely saved the day for our family. Both the heat and AC went out in our home, and with temperatures climbing fast, we were stressed and uncomfortable. From the very first call, Juliano was responsive and got us taken care of quickly.',
  },
  {
    name: 'Audra Dunphy',
    rating: 5,
    date: '3 months ago',
    text: 'Three days after we moved in we noticed a leak on our second floor ceiling, it was a Saturday at 3pm and I was worried. After calling about 5 other companies from a Google search that couldn\'t see us for days, I called Romanos and was in great hands right away.',
  },
  {
    name: 'Joe DelMarmol',
    rating: 5,
    date: '3 months ago',
    text: 'Juliano was excellent!!! He was very professional, courteous, and explained the system and the installation wonderfully. Rick, also, was very courteous and helpful. We will certainly recommend you to our friends and neighbors.',
  },
  {
    name: 'Verified Reviewer',
    rating: 5,
    date: 'Recent',
    text: 'They did a WONDERFUL job, and we are SO grateful for their service!!!',
  },
  {
    name: 'Verified Reviewer',
    rating: 5,
    date: 'Recent',
    text: 'Very knowledgeable and professional...excellence service and work ethic.',
  },
  {
    name: 'Verified Reviewer',
    rating: 5,
    date: 'Recent',
    text: 'I highly recommend this company and will be using him for my HVAC needs.',
  },
];

const ReviewsShowcase = () => {
  return (
    <section className="py-20 bg-white" data-testid="reviews-showcase">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="romano-badge mb-4 inline-block">Google Reviews</span>
          <h2 className="romano-heading text-3xl sm:text-4xl font-bold text-[#622B62] mb-4">
            What Our Customers Are Saying
          </h2>
          <div className="section-divider mx-auto mb-6" />
          <div className="flex items-center justify-center gap-3 mb-2">
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={22} className={i < 5 ? "text-[#DA9C3A] fill-[#DA9C3A]" : "text-gray-300"} />
              ))}
            </div>
            <span className="font-bold text-[#622B62] text-lg">4.8</span>
            <span className="text-gray-500">based on 103 Google reviews</span>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review, index) => (
            <div
              key={index}
              data-testid={`review-card-${index}`}
              className="bg-[#FDFCF7] rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-md transition-shadow"
            >
              {/* Google Icon + Stars */}
              <div className="flex items-center justify-between mb-4">
                <div className="flex gap-0.5">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} size={16} className="text-[#DA9C3A] fill-[#DA9C3A]" />
                  ))}
                </div>
                <svg viewBox="0 0 24 24" className="w-5 h-5" aria-label="Google">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                </svg>
              </div>

              {/* Review Text */}
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                "{review.text}"
              </p>

              {/* Author */}
              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <h4 className="font-bold text-[#622B62] text-sm">{review.name}</h4>
                <span className="text-gray-400 text-xs">{review.date}</span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <a
            href="https://maps.app.goo.gl/Egqd3ZEm5Ewd7YU29"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => { e.preventDefault(); window.open('https://maps.app.goo.gl/Egqd3ZEm5Ewd7YU29', '_blank') || (window.location.href = 'https://maps.app.goo.gl/Egqd3ZEm5Ewd7YU29'); }}
            className="inline-flex items-center gap-2 text-[#622B62] font-semibold hover:text-[#DA9C3A] transition-colors"
          >
            See all 103 reviews on Google <ExternalLink size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default ReviewsShowcase;
